import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { NotificationHubSdk } from 'src/app/sdks/notification.hub-sdk';
import { AuthenticationService } from "@services/authentication.service";
import { ExperienceManager } from "@managers/experience.manager";

@Component({
    selector: 'lex-app-container',
    templateUrl: './app-container.component.html',
    styleUrls: ['./app-container.component.scss'],
    standalone: false
})
export class AppContainerComponent implements OnDestroy {
	public copyright = 'Copyright © 2006-' + new Date().getFullYear().toString().slice(-2) + '. All rights reserved';
	public servicesAgreement = 'Use of eDiscoveryPlatform services and this site constitutes acceptance of the Master Services Agreement. ' + this.copyright;
	public showHeader: boolean = true;
	public showFooter: boolean = true;
	public showDocViewerToggle: boolean = false;
	public subscription: Subscription = new Subscription();

	constructor(
		public notificationHubSdk: NotificationHubSdk,
		private activatedRoute: ActivatedRoute,
		private authenticationService: AuthenticationService,
		private experienceManager: ExperienceManager,
	) {
		const params$ = this.activatedRoute.queryParamMap;
		const experienceState$ = this.experienceManager.state$;
		const legacySubscription = combineLatest([params$, experienceState$]).subscribe(([params, current]) => {
			this.showHeader = !(params?.has('suppressMenu')) && current?.showTopBar === true;
			this.showFooter = !params?.has('suppressMenu');
		});
		this.subscription.add(legacySubscription);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	public showLeftMenu(): boolean {
		// Find the first URL segment (child) that wishes to hide the left menu - if any such child exists
		let hideLeftMenu = false;
		let nextRoute = this.activatedRoute.snapshot;
		while (nextRoute) {
			if (nextRoute.data.hideLeftMenu) {
				hideLeftMenu = true;
				break;
			}

			nextRoute = nextRoute.firstChild;
		}

		return !hideLeftMenu && this.authenticationService.isLoggedIn();
	}
}
